module.exports = __webpack_public_path__ + "static/media/xk.bab9140c.svg";